export const fontWeight = {
    'light': 100,
    'regular': 500,
    'bold': 700
}

export const fontSize = [0.64, 0.8, 1, 1.25, 1.563, 1.953, 2.441, 3.052, 3.815, 4.768, 5.96, 7.451].map((n) => `${n}rem`);

export const space = [0, 0.125, 0.25, 0.5, 1, 2, 4, 8, 16].map((n) => `${n}rem`);

export const fontFamily = '-apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'helvetica neue\', helvetica, arial, sans-serif';

export const agenda = '\'agenda\'';

export const inter = '\'Inter\'';